import type { SVGProps } from 'react';
export const IconKitDownload = (props: SVGProps<SVGSVGElement>) => (
  <svg
    width="1em"
    height="1em"
    viewBox="0 0 24 24"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
    {...props}
  >
    <path
      d="M8.5 12.4L12 16M12 16L15.5 12.4M12 16L12 4.3"
      stroke="currentColor"
      strokeLinecap="round"
    />
    <path
      d="M5 15L5 18.2C5 18.6774 5.18437 19.1352 5.51256 19.4728C5.84075 19.8104 6.28587 20 6.75 20H17.25C17.7141 20 18.1592 19.8104 18.4874 19.4728C18.8156 19.1352 19 18.6774 19 18.2V15"
      stroke="currentColor"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
  </svg>
);
